import itemParser from './item';

import channelTypes from '../../../constants/channel-types';
import transcodingStatuses from '../../../constants/transcoding-statuses';

import { keysToCamelCase, removeUndefinedValues } from '@wix/wix-vod-shared/src/common/utils/object';
import { normalizeId } from '../../../utils/normalize-id';


export default function (adapterMethods, listData) {
  listData = keysToCamelCase(listData);

  const {
    itemId: id,
    customCoverUrl,
    usedCount: videosCount,
    publishChanges: hasChangesToPublish,
    featuredItem,
    urlType = '',
    channelType = channelTypes.CHANNEL,
  } = listData;

  let {
    createdTs,
    externalCreatedTs,
    updatedTs,
    publishedTs = createdTs,
    statsInfo,
  } = listData;

  createdTs = new Date(createdTs * 1000);
  externalCreatedTs = new Date(externalCreatedTs * 1000);
  updatedTs = new Date(updatedTs * 1000);
  if (publishedTs) {
    publishedTs = new Date(publishedTs * 1000);
  }

  if (statsInfo) {
    statsInfo = _.mapValues(statsInfo, list => {
      // get rid of empty categories & tags
      const nonEmptyList = _.filter(list, item => Boolean(item.value));
      return _.uniqBy(nonEmptyList, 'value');
    });
  }

  // TODO: add mapping instead assign
  listData = _({})
    .assign(listData, {
      id: normalizeId(id),
      customCoverUrl: customCoverUrl || null,
      videosCount,
      createdTs,
      externalCreatedTs,
      updatedTs,
      publishedTs,
      hasChangesToPublish,
      urlType,
      channelType,
      featuredItem: itemParser(adapterMethods, featuredItem),
      statsInfo,
    })
    .omit('itemId', 'usedCount', 'publishChanges')
    .value();

  // TODO: remove after add filtering on server side. Fix failed video, marked as featured
  if (listData.featuredItem && listData.featuredItem.transcodingStatus === transcodingStatuses.NONE) {
    listData = _.omit(listData, 'featuredItem');

    if (listData.videosCount) {
      listData.videosCount += -1;
    }
  }

  if (channelType !== channelTypes.CHANNEL) {
    listData = _.omit(listData, 'videosCount');
  }

  return removeUndefinedValues(listData);
}



// WEBPACK FOOTER //
// ./src/transport/adapters/vod/parsers/list.js